import script from "./generic-dropdown-container.vue?vue&type=script&setup=true&lang=js"
export * from "./generic-dropdown-container.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__